import { azureFetch} from "./azureFetch"


export const fetchAnalysisDataList = async (filters, order_by, order_dir) => {
    try {
        const response = await azureFetch('AnalysisDataList', {where_clause: filters,
                    order_by,
                    order_dir
            });
        return response.data;
    } catch (error) {
        console.error("Error fetching analysis data:", error);
        throw error;
    }
};

export const getFeatures = async (requestBody) => {
    try {

        const response = await azureFetch('AnalysisGetFeatures', requestBody);
        return response;
    } catch (error) {
        console.error("Error fetching features:", error);
        throw error;
    }
};